module.exports = __webpack_public_path__ + "static/img/project_analysis.3ae53a1b.png";